import React from 'react';
import { Navigate } from 'react-router-dom';

// Component imports
import HabitTracker from '../components/habits/HabitTracker';
import HabitDetail from '../components/habits/HabitDetail';
import HabitEdit from '../components/habits/HabitEdit';
import { GoalManagement, GoalDetail } from '../components/goals';
import GoalEdit from '../components/goals/GoalEdit';
import LifeOKR from '../components/goals/LifeOKR';
import { Metrics } from '../components/metrics';
import MetricDetail from '../components/metrics/MetricDetail';
import MetricBuilder from '../components/metrics/MetricBuilder';
import Lifetime from '../components/Lifetime';
import Days from '../components/Days_v2';
import Notes from '../components/notes/Notes';
import Note from '../components/notes/Note';
import BlockPage from '../components/notes/BlockPage';
import TaskManagement from '../components/tasks/TaskManagement';
import TaskDetail from '../components/tasks/TaskDetail';
import Timer from '../components/Timer';
import FinanceAssets from '../components/finance/FinanceAssets';
import AssetDetail from '../components/finance/AssetDetail';
import StockPortfolio from '../components/stock-portfolio/StockPortfolio';
import CompanyDetail from '../components/stock-portfolio/CompanyDetail';
import TransactionDetail from '../components/stock-portfolio/TransactionDetail';
import Logs from '../components/Logs';
import Weeks from '../components/Weeks';
import Months from '../components/Months';
import Years from '../components/Years';
import Timeline from '../components/Timeline';
import Settings from '../components/Settings';
import Learn from '../components/learn/Learn';
import LearningModule from '../components/learn/LearningModule';
import LessonStudy from '../components/learn/LessonStudy';
import Library from '../components/books/Library';
import BookPage from '../components/books/BookPage';
import BookDetail from '../components/books/BookDetail';
import MoviePage from '../components/movies/MoviePage';
import MovieDetail from '../components/movies/MovieDetail';
import GenericChat from '../components/chat/GenericChat';
import Social from '../components/social/Social';
import PostDetail from '../components/social/PostDetail';
import Novels from '../components/novels/Novels';
import NovelEditor from '../components/novels/NovelEditor';
import NovelMetadataEditor from '../components/novels/NovelMetadataEditor';
import PlotsListEditor from '../components/novels/PlotsListEditor';
import PlotEditor from '../components/novels/PlotEditor';
import CharactersListEditor from '../components/novels/CharactersListEditor';
import CharacterEditor from '../components/novels/CharacterEditor';
import ChapterEditorPage from '../components/novels/ChapterEditorPage';
import AIWriterPage from '../components/novels/AIWriterPage';
import PublicNovelReader from '../components/novels/PublicNovelReader';
import ChapterReaderPage from '../components/novels/ChapterReaderPage';
import ChineseLearn from '../components/language-chinese/ChineseLearn';
import ChineseReading from '../components/language-chinese/ChineseReading';
import ChinesePracticeTranslation from '../components/language-chinese/ChinesePracticeTranslation';
import ChineseCharacter from '../components/language-chinese/ChineseCharacter';
import ChineseWritingCopilot from '../components/language-chinese/ChineseWritingCopilot';
import FrenchLearn from '../components/language-french/FrenchLearn';
import HindiLearn from '../components/language-hindi/HindiLearn';
import HindiReading from '../components/language-hindi/HindiReading';
import HindiCharacter from '../components/language-hindi/HindiCharacter';
import HindiAlphabet from '../components/language-hindi/HindiAlphabet';
import FinanceForInvestor from '../components/learn-finance/FinanceForInvestor';
import KnowledgeCategories from '../components/knowledge/KnowledgeCategories';
import CategoryLessonView from '../components/knowledge/CategoryLessonView';
import MCQPractice from '../components/mcq-practice/MCQPractice';
import MusicSheets from '../components/music/MusicSheets';
import MusicSheetEditor from '../components/music/MusicSheetEditor';
import Videos from '../components/videos/Videos';
import Images from '../components/images/Images';
import Sounds from '../components/sounds/Sounds';
import News from '../components/news/News';
import Feeds from '../components/feeds/Feeds';
import FeedSourceManagement from '../components/feeds/FeedSourceManagement';
import Maps from '../components/maps/Maps';
import CashflowPage from '../components/cashflow/CashflowPage';
import GoldPrices from '../components/gold-prices/GoldPrices';
import MemoryPalace from '../components/memory-palace/MemoryPalace';
import PlaceDetail from '../components/memory-palace/PlaceDetail';
import PasswordPage from '../components/passwords/PasswordPage';
import Meditation from '../components/meditation/Meditation';
import PeopleList from '../components/people/PeopleList';
import PeopleDetail from '../components/people/PeopleDetail';
import PeopleEdit from '../components/people/PeopleEdit';
import AICharacterManagement from '../components/ai-characters/AICharacterManagement';
import AICharacterDetail from '../components/ai-characters/AICharacterDetail';
import AICharacterEdit from '../components/ai-characters/AICharacterEdit';
import TimeTunnel from '../components/time-tunnel/TimeTunnel';
import ActivitiesPage from '../components/activities/ActivitiesPage';
import Drawing from '../components/drawing/Drawing';
import MemoryTechnique from '../components/memory-technique/MemoryTechnique';
import Dashboard from '../components/dashboard/Dashboard';
import Whiteboard from '../components/whiteboard/Whiteboard';
import WhiteboardDetail from '../components/whiteboard/WhiteboardDetail';
import Garden from '../components/garden/Garden';
import SkillMap from '../components/skillmap/SkillMap';
import SkillEdit from '../components/skillmap/SkillEdit';
import SkillRoadmapYear from '../components/skillmap/SkillRoadmapYear';
import LifeEventsPage from '../components/life-events/LifeEventsPage';
import PeriodCalendar from '../components/period-calendar/PeriodCalendar';
import ProjectManagement from '../components/projects/ProjectManagement';
import ProjectDetail from '../components/projects/ProjectDetail';
import ProjectEdit from '../components/projects/ProjectEdit';
import CriticalThinkingPractice from '../components/critical-thinking/CriticalThinkingPractice';
import VocabularyMatrix from '../components/vocabulary/VocabularyMatrix';
import Essays from '../components/essays/Essays';
import EssayEditor from '../components/essays/EssayEditor';
import CuriosityPage from '../components/curiosity/CuriosityPage';
import SeaOfKnowledge from '../components/sea-of-knowledge/SeaOfKnowledge';
import Mindmap from '../components/mindmap/Mindmap';
import MindmapCanvas from '../components/mindmap/MindmapCanvas';
import MandalaManagement from '../components/mandala/MandalaManagement';
import MandalaDetail from '../components/mandala/MandalaDetail';
import ThinkingFrameworks from '../components/thinking-frameworks/ThinkingFrameworks';
import SWOTAnalysis from '../components/thinking-frameworks/SWOTAnalysis';
import FiveWhysAnalysis from '../components/thinking-frameworks/FiveWhysAnalysis';
import FirstPrinciplesAnalysis from '../components/thinking-frameworks/FirstPrinciplesAnalysis';
import SecondOrderThinking from '../components/thinking-frameworks/SecondOrderThinking';
import Schedule from '../components/Schedule';

export interface RouteConfig {
  path: string;
  component: React.ComponentType<any>;
  layout?: 'standard' | 'fullscreen' | 'special';
  fullscreenClass?: string;
  protected?: boolean;
  showSidebar?: boolean;
  exactPath?: boolean;
}

/**
 * Centralized route configuration for the application
 * Each route can specify:
 * - component: The component to render
 * - layout: 'standard' (with sidebar + main), 'fullscreen' (with sidebar only), or 'special' (custom layout)
 * - fullscreenClass: CSS class for fullscreen layouts
 * - protected: Whether route requires authentication
 * - showSidebar: Whether to show sidebar (default true for protected routes)
 */
export const routeConfigs: RouteConfig[] = [
  // Habits routes
  {
    path: '/habits',
    component: HabitTracker,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-habits',
    protected: true,
  },
  {
    path: '/habits/:id',
    component: HabitDetail,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-habits',
    protected: true,
  },
  {
    path: '/habits/:id/edit',
    component: HabitEdit,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-habits',
    protected: true,
  },

  // Goals routes
  {
    path: '/goals',
    component: GoalManagement,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-goals',
    protected: true,
  },
  {
    path: '/goals/:id/edit',
    component: GoalEdit,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-goals',
    protected: true,
  },
  {
    path: '/goals/:id',
    component: GoalDetail,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-goals',
    protected: true,
  },
  {
    path: '/life-okr',
    component: LifeOKR,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-goals',
    protected: true,
  },

  // Timeline
  {
    path: '/timeline',
    component: Timeline,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-timeline',
    protected: true,
  },

  // Tasks routes
  {
    path: '/tasks',
    component: TaskManagement,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-tasks',
    protected: true,
  },
  {
    path: '/tasks/:id',
    component: TaskDetail,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-tasks',
    protected: true,
  },

  // Schedule routes
  {
    path: '/schedule/:date',
    component: Schedule,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-schedule',
    protected: true,
  },
  {
    path: '/schedule',
    component: Schedule,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-schedule',
    protected: true,
  },

  // Timer
  {
    path: '/timer',
    component: Timer,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-timelogs',
    protected: true,
  },

  // Finance routes
  {
    path: '/finance/assets',
    component: FinanceAssets,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-finance',
    protected: true,
  },
  {
    path: '/finance/assets/:id',
    component: AssetDetail,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-finance',
    protected: true,
  },

  // Stock Portfolio routes
  {
    path: '/finance/stocks',
    component: StockPortfolio,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-stocks',
    protected: true,
  },
  {
    path: '/finance/stocks/transaction/:id',
    component: TransactionDetail,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-stocks',
    protected: true,
  },
  {
    path: '/finance/stocks/company/:stockCode',
    component: CompanyDetail,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-stocks',
    protected: true,
  },

  // Logs
  {
    path: '/logs',
    component: Logs,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-logs',
    protected: true,
  },

  // Weeks
  {
    path: '/weeks/:yearWeek',
    component: Weeks,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-weeks',
    protected: true,
  },

  // Months
  {
    path: '/months/:yearMonth',
    component: Months,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-months',
    protected: true,
  },

  // Years
  {
    path: '/years/:year',
    component: Years,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-years',
    protected: true,
  },

  // Metrics
  {
    path: '/metrics',
    component: Metrics,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-metrics',
    protected: true,
  },
  {
    path: '/metrics/builder',
    component: MetricBuilder,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-metrics',
    protected: true,
  },
  {
    path: '/metrics/:name',
    component: MetricDetail,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-metrics',
    protected: true,
  },

  // Notes routes
  {
    path: '/notes',
    component: Notes,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-notes',
    protected: true,
  },
  {
    path: '/notes/:noteId',
    component: Note,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-notes',
    protected: true,
  },

  // Block page
  {
    path: '/block/:block_id',
    component: BlockPage,
    layout: 'standard',
    protected: true,
  },

  // Settings
  {
    path: '/settings',
    component: Settings,
    layout: 'standard',
    protected: true,
  },

  // Library
  {
    path: '/library',
    component: Library,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-library',
    protected: true,
  },

  // Books (with reading progress)
  {
    path: '/books',
    component: BookPage,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-books',
    protected: true,
  },
  {
    path: '/books/:bookId',
    component: BookDetail,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-books',
    protected: true,
  },

  // Movies
  {
    path: '/movies',
    component: MoviePage,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-movies',
    protected: true,
  },
  {
    path: '/movies/:movieId',
    component: MovieDetail,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-movies',
    protected: true,
  },

  // Learn routes
  {
    path: '/learn',
    component: Learn,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-learn',
    protected: true,
  },
  {
    path: '/chinese',
    component: ChineseLearn,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-chinese',
    protected: true,
  },
  {
    path: '/chinese/reading',
    component: ChineseReading,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-chinese',
    protected: true,
  },
  {
    path: '/chinese/practice',
    component: ChinesePracticeTranslation,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-chinese',
    protected: true,
  },
  {
    path: '/chinese/character',
    component: ChineseCharacter,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-chinese',
    protected: true,
  },
  {
    path: '/chinese/writing-copilot',
    component: ChineseWritingCopilot,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-chinese',
    protected: true,
  },
  {
    path: '/french',
    component: FrenchLearn,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-french',
    protected: true,
  },
  {
    path: '/hindi',
    component: HindiLearn,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-hindi',
    protected: true,
  },
  {
    path: '/hindi/reading',
    component: HindiReading,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-hindi',
    protected: true,
  },
  {
    path: '/hindi/character',
    component: HindiCharacter,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-hindi',
    protected: true,
  },
  {
    path: '/hindi/alphabet',
    component: HindiAlphabet,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-hindi',
    protected: true,
  },
  {
    path: '/finance-investor',
    component: FinanceForInvestor,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-finance-investor',
    protected: true,
  },
  {
    path: '/knowledge',
    component: KnowledgeCategories,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-knowledge',
    protected: true,
  },
  {
    path: '/knowledge/:categoryId',
    component: CategoryLessonView,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-knowledge',
    protected: true,
  },
  {
    path: '/mcq-practice',
    component: MCQPractice,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-mcq-practice',
    protected: true,
  },
  {
    path: '/music-sheets',
    component: MusicSheets,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-music-sheets',
    protected: true,
  },
  {
    path: '/music-sheets/editor/:sheetId',
    component: MusicSheetEditor,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-music-sheets',
    protected: true,
  },
  {
    path: '/learn/:moduleId',
    component: LearningModule,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-learn',
    protected: true,
  },
  {
    path: '/learn/:moduleId/:lessonId',
    component: LessonStudy,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-learn',
    protected: true,
  },

  // Days routes
  {
    path: '/days/:date',
    component: Days,
    layout: 'standard',
    protected: true,
  },

  // Lifetime
  {
    path: '/lifetime',
    component: Lifetime,
    layout: 'standard',
    protected: true,
  },

  // Chat
  {
    path: '/chat',
    component: GenericChat,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-chat',
    protected: true,
  },

  // Social
  {
    path: '/social',
    component: Social,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-social',
    protected: true,
  },
  {
    path: '/social/:postId',
    component: PostDetail,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-social',
    protected: true,
  },

  // Videos
  {
    path: '/videos',
    component: Videos,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-videos',
    protected: true,
  },

  // Images
  {
    path: '/images',
    component: Images,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-images',
    protected: true,
  },

  // Sounds
  {
    path: '/sounds',
    component: Sounds,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-sounds',
    protected: true,
  },

  // News
  {
    path: '/news',
    component: News,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-news',
    protected: true,
  },

  // Feeds
  {
    path: '/feeds',
    component: Feeds,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-feeds',
    protected: true,
  },
  {
    path: '/feeds/sources',
    component: FeedSourceManagement,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-feeds-management',
    protected: true,
  },

  // Maps
  {
    path: '/maps',
    component: Maps,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-maps',
    protected: true,
  },

  // Cashflow
  {
    path: '/cashflow',
    component: CashflowPage,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-cashflow',
    protected: true,
  },

  // Gold Prices
  {
    path: '/gold-prices',
    component: GoldPrices,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-gold-prices',
    protected: true,
  },

  // Novels
  {
    path: '/novel',
    component: Novels,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-novels',
    protected: true,
  },
  {
    path: '/novel/public/:novelId/chapter/:chapterId',
    component: ChapterReaderPage,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-novels',
    protected: true,
  },
  {
    path: '/novel/public/:novelId',
    component: PublicNovelReader,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-novels',
    protected: true,
  },
  {
    path: '/novel/:novelId/metadata/plots/:plotIndex',
    component: PlotEditor,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-novels',
    protected: true,
  },
  {
    path: '/novel/:novelId/metadata/plots',
    component: PlotsListEditor,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-novels',
    protected: true,
  },
  {
    path: '/novel/:novelId/metadata/characters/:characterIndex',
    component: CharacterEditor,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-novels',
    protected: true,
  },
  {
    path: '/novel/:novelId/metadata/characters',
    component: CharactersListEditor,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-novels',
    protected: true,
  },
  {
    path: '/novel/:novelId/metadata',
    component: NovelMetadataEditor,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-novels',
    protected: true,
  },
  {
    path: '/novel/:novelId/chapter/:chapterId/ai-writer',
    component: AIWriterPage,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-novels',
    protected: true,
  },
  {
    path: '/novel/:novelId/chapter/:chapterId',
    component: ChapterEditorPage,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-novels',
    protected: true,
  },
  {
    path: '/novel/:novelId',
    component: NovelEditor,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-novels',
    protected: true,
  },

  // Memory Palace
  {
    path: '/memory',
    component: MemoryPalace,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-memory',
    protected: true,
  },
  {
    path: '/memory/:id',
    component: PlaceDetail,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-memory',
    protected: true,
  },

  // Passwords
  {
    path: '/passwords',
    component: PasswordPage,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-passwords',
    protected: true,
  },

  // Meditation
  {
    path: '/meditation',
    component: Meditation,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-meditation',
    protected: true,
  },

  // People Management
  {
    path: '/people',
    component: PeopleList,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-people',
    protected: true,
  },
  {
    path: '/people/new',
    component: PeopleEdit,
    layout: 'standard',
    protected: true,
  },
  {
    path: '/people/:id',
    component: PeopleDetail,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-people',
    protected: true,
  },
  {
    path: '/people/:id/edit',
    component: PeopleEdit,
    layout: 'standard',
    protected: true,
  },

  // AI Character Management
  {
    path: '/ai-characters',
    component: AICharacterManagement,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-ai-characters',
    protected: true,
  },
  {
    path: '/ai-characters/new',
    component: AICharacterEdit,
    layout: 'standard',
    protected: true,
  },
  {
    path: '/ai-characters/:id',
    component: AICharacterDetail,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-ai-characters',
    protected: true,
  },
  {
    path: '/ai-characters/:id/edit',
    component: AICharacterEdit,
    layout: 'standard',
    protected: true,
  },

  // Time Tunnel
  {
    path: '/time-tunnel',
    component: TimeTunnel,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-time-tunnel',
    protected: true,
  },

  // Activities
  {
    path: '/activities',
    component: ActivitiesPage,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-activities',
    protected: true,
  },

  // Drawing
  {
    path: '/drawing',
    component: Drawing,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-drawing',
    protected: true,
  },

  // Memory Technique
  {
    path: '/memory-technique',
    component: MemoryTechnique,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-memory-technique',
    protected: true,
  },

  // Dashboard
  {
    path: '/dashboard',
    component: Dashboard,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-dashboard',
    protected: true,
  },

  // Whiteboard routes
  {
    path: '/whiteboard',
    component: Whiteboard,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-whiteboard',
    protected: true,
  },
  {
    path: '/whiteboard/:id',
    component: WhiteboardDetail,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-whiteboard',
    protected: true,
  },

  // Garden route
  {
    path: '/garden',
    component: Garden,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-garden',
    protected: true,
  },

  // SkillMap routes
  {
    path: '/skillmap',
    component: SkillMap,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-skillmap',
    protected: true,
  },
  {
    path: '/skillmap/new',
    component: SkillEdit,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-skillmap',
    protected: true,
  },
  {
    path: '/skillmap/:id/edit',
    component: SkillEdit,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-skillmap',
    protected: true,
  },
  {
    path: '/skillmap/:year',
    component: SkillRoadmapYear,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-skillmap',
    protected: true,
  },

  // Life Events routes
  {
    path: '/life-events',
    component: LifeEventsPage,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-life-events',
    protected: true,
  },

  // Period Calendar routes
  {
    path: '/period-calendar',
    component: PeriodCalendar,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-period-calendar',
    protected: true,
  },

  // Projects routes
  {
    path: '/projects',
    component: ProjectManagement,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-projects',
    protected: true,
  },
  {
    path: '/projects/new',
    component: ProjectEdit,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-projects',
    protected: true,
  },
  {
    path: '/projects/:id',
    component: ProjectDetail,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-projects',
    protected: true,
  },
  {
    path: '/projects/:id/edit',
    component: ProjectEdit,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-projects',
    protected: true,
  },

  // Critical Thinking Practice
  {
    path: '/critical-thinking',
    component: CriticalThinkingPractice,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-critical-thinking',
    protected: true,
  },

  // Vocabulary routes
  {
    path: '/vocabulary',
    component: VocabularyMatrix,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-vocabulary',
    protected: true,
  },

  // Essays routes
  {
    path: '/essays',
    component: Essays,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-essays',
    protected: true,
  },
  {
    path: '/essays/:essayId',
    component: EssayEditor,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-essays',
    protected: true,
  },

  // Curiosity route
  {
    path: '/curiosity',
    component: CuriosityPage,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-curiosity',
    protected: true,
  },

  // Sea of Knowledge route
  {
    path: '/sea-of-knowledge',
    component: SeaOfKnowledge,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-sea-of-knowledge',
    protected: true,
  },

  // Mindmap route
  {
    path: '/mindmap',
    component: Mindmap,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-mindmap',
    protected: true,
  },
  {
    path: '/mindmap/:id',
    component: MindmapCanvas,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-mindmap',
    protected: true,
  },

  // Mandala route
  {
    path: '/mandala',
    component: MandalaManagement,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-mandala',
    protected: true,
  },
  {
    path: '/mandala/:id',
    component: MandalaDetail,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-mandala',
    protected: true,
  },

  // Thinking Frameworks routes
  {
    path: '/thinking-frameworks',
    component: ThinkingFrameworks,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-thinking-frameworks',
    protected: true,
  },
  {
    path: '/thinking-frameworks/swot',
    component: SWOTAnalysis,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-thinking-frameworks',
    protected: true,
  },
  {
    path: '/thinking-frameworks/swot/:sessionId',
    component: SWOTAnalysis,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-thinking-frameworks',
    protected: true,
  },
  
  // 5 Whys routes
  {
    path: '/thinking-frameworks/5whys',
    component: FiveWhysAnalysis,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-thinking-frameworks',
    protected: true,
  },
  {
    path: '/thinking-frameworks/5whys/:sessionId',
    component: FiveWhysAnalysis,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-thinking-frameworks',
    protected: true,
  },

  // First Principles routes
  {
    path: '/thinking-frameworks/first_principles',
    component: FirstPrinciplesAnalysis,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-thinking-frameworks',
    protected: true,
  },
  {
    path: '/thinking-frameworks/first_principles/:sessionId',
    component: FirstPrinciplesAnalysis,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-thinking-frameworks',
    protected: true,
  },

  // Second-Order Thinking routes
  {
    path: '/thinking-frameworks/second_order',
    component: SecondOrderThinking,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-thinking-frameworks',
    protected: true,
  },
  {
    path: '/thinking-frameworks/second_order/:sessionId',
    component: SecondOrderThinking,
    layout: 'fullscreen',
    fullscreenClass: 'fullscreen-thinking-frameworks',
    protected: true,
  },
];

/**
 * Helper function to get today's date path
 */
export const getTodayPath = () => {
  return `/days/${new Date().toISOString().split('T')[0]}`;
};

/**
 * Redirect configurations
 */
export const getRedirectRoutes = () => [
  { from: '/', to: getTodayPath() },
  { from: '/days', to: getTodayPath() },
  { from: '/weeks', to: '/weeks/current' },
  { from: '/months', to: '/months/current' },
  { from: '/years', to: '/years/current' },
];

